import { PromoCode } from '@fantaz/shared/data-access/models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as PromoCodeActions from './promo-code.actions';

export const PROMO_CODE_FEATURE_KEY = 'promoCodes';

export interface PromoCodeState extends EntityState<PromoCode> {
  selectedId?: string | number; // which PromoCode record has been selected
  loaded: boolean; // has the PromoCode list been loaded
  loading: boolean; // has the PromoCode list been loading
  error?: string | null; // last known error (if any)
  total: number; // number of promo codes in the database
}

export interface PromoCodePartialState {
  readonly [PROMO_CODE_FEATURE_KEY]: PromoCodeState;
}

export const promoCodeAdapter: EntityAdapter<PromoCode> =
  createEntityAdapter<PromoCode>({
    selectId: (promoCode: PromoCode) => promoCode.uuid,
  });

export const promoCodeInitialState: PromoCodeState =
  promoCodeAdapter.getInitialState({
    // set initial required properties
    loaded: false,
    loading: false,
    total: 0,
  });

const reducer = createReducer(
  promoCodeInitialState,
  on(PromoCodeActions.loadPromoteCodes, (state) => ({
    ...state,
    loaded: false,
    loading: true,
    error: null,
  })),
  on(PromoCodeActions.loadPromoCodesSuccess, (state, { promoCodes, total }) => {
    return promoCodeAdapter.setAll(promoCodes, {
      ...state,
      total,
      loaded: true,
      loading: false,
    });
  }),
  on(PromoCodeActions.confirmPromoCodeSuccess, (state, { promoCode }) =>
    promoCodeAdapter.addOne(promoCode, state),
  ),
  on(PromoCodeActions.loadPromoCodesFailure, (state, { error }) => ({
    ...state,
    false: true,
    loading: false,
    error,
  })),
);

export function promoCodeReducer(
  state: PromoCodeState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
